import React, { useState, useEffect, useRef } from "react";

import "./App.css";
import "./AuraSpin.css";
import aurasData from "./auras.js";
import { AnimatePresence, easeInOut, motion } from "framer-motion";
import axios from "axios";
import LuckAnimation from "./TextAnimation.js";
import ClickBar from "./ClickBar.js";
import SpinButton from "./SpinButton.js";
import SellIcon from "./Icons/SellIcon.js";
import TakeIcon from "./Icons/TakeIcon.js";
import { Player } from "@lottiefiles/react-lottie-player";
import useToast from "./Toast/useToast";
import ToastNotification from "./Toast/ToastNotification";
import { Ripple, PopCoins, pop } from "./Effects.js";
import AurasIcon from "./Icons/AurasIcon.js";
import InventoryIcon from "./Icons/InventoryIcon.js";
import MiniGame from "./MiniGame.js";
import auraBgList from "./Backgrounds.js";
import audioManager from "./Sounds.js";

import {
  getRarity,
  getRarityColor,
  getAuraByName,
  createQueue,
  formatNumber,
  calculateStats,
  getRandomNumber,
  calculateProbability,
  calculateAuraCost,
  enrichAndSortAuras,
} from "./Functions";

import shopItems from "./shopItems.js";
import { getItemByName } from "./Functions";

import sewingAnim from "./sewing.json";
import alchemistAnim from "./potionSpin.json";
import PotionContainer from "./PotionContainer.js";
import CityIcon from "./Icons/CityIcon.js";
import SpinningWindow from "./SpinningWindow.js";
import forgeItems from "./BlacksmithItems.js";
import tailorItems from "./TailorItems.js";
import ActiveItem from "./ActiveItem.js";
import ItemsInventory from "./ItemsInventory.js";
import AurasInventory from "./AurasInventory.js";
import Blacksmith from "./Blacksmith.js";
import TailorIcon from "./Icons/TailorIcon.js";
import alchemistItems from "./AlchemistItems.js";
import adventuresList from "./AdventuresList.js";
import AlchemistIcon from "./Icons/AlchemistIcon.js";
import Dungeon from "./DungeonActive.js";
import BpIcon from "./Icons/BpIcon.js";
import CityWindow from "./CityWindow.js";
import Shop from "./Shop.js";
import Pirate from "./Pirate.js";
import { dailyRewards } from "./Rewards.js";
import RareAuraTicker from "./RareAuraTicker.jsx";
import { useSocket } from "./SocketContext.js";

//////Рандомная аура
const getRandomAura = (weight) => {
  const finalWeight = weight < 10 ? weight : Math.random() < 0.7 ? 10 : weight;
  const newWeight = finalWeight + 1;
  // Фильтруем ауры:
  // 1. Отбрасываем первые `newWeight - 1` элементов.
  // 2. Исключаем ауры с `limited: true`.
  const filteredAuras = aurasData
    .slice(newWeight - 1)
    .filter((aura) => !aura.limited); // Добавляем проверку на limited

  // Если массив пуст, возвращаем "None"
  if (filteredAuras.length === 0) {
    console.log("NO FILTERED AURAS (excluding limited)");
    return "None";
  }

  const weightExponent = 1; // Можно настроить, если нужно
  const sumOfProbabilities = filteredAuras.reduce(
    (sum, aura) => sum + Math.pow(1 / aura.probability, weightExponent),
    0
  );

  const rand = Math.random() * sumOfProbabilities;
  let cumulativeProbability = 0;

  for (let aura of filteredAuras) {
    cumulativeProbability += Math.pow(1 / aura.probability, weightExponent);
    if (rand < cumulativeProbability) {
      return aura;
    }
  }

  return "None";
};

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
  },
});

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const AuraRng = ({
  dispatch,
  localProfile,
  t,
  sendSpinning,
  farm,
  changeDealDucks,
  sendNowOpen,
  tgId,
  tgUsername,
}) => {
  const [currentAura, setCurrentAura] = useState(null);
  const [spinAura, setSpinAura] = useState({});
  const [spinning, setSpinning] = useState(false);
  const [takeButtonDisabled, setTakeButtonDisabled] = useState(true);

  const [aurasQuantity, setAurasQuantity] = useState(0);

  const [spinsCountUntilLucky, setSpinsUntilLucky] = useState(10);

  const salary = useRef();

  const { toasts, addToast } = useToast();

  const updateAndSortAuras = async (aurasList) => {
    const sorted = await enrichAndSortAuras(aurasList);

    dispatch({ type: "UPDATE_AURAS", payload: sorted });
  };
  const { emit, on, off, once, isConnected } = useSocket();

  useEffect(() => {
    const setLocalProfile = async () => {
      try {
        let aura = await getAuraByName(localProfile.mainAura);
        aura = {
          ...aura,
          auraLvl: localProfile.mainAuraLvl,
          auraBg: localProfile.mainAuraBg,
        };
        setCurrentAura(aura);
        updateAndSortAuras(localProfile.AurasList);

        setSortedItems(localProfile.ItemsList);
        fetchEquipped(
          localProfile.ring,
          localProfile.glove,
          localProfile.neck,
          localProfile.head
        );

        const lastRewardDate = new Date(localProfile.lastDailyReward);
        const today = new Date();
        const diff =
          (today.getTime() - lastRewardDate.getTime()) / (1000 * 60 * 60 * 24); // Разница в днях
        console.log("DIFF:", diff);

        // Если прошло от 1 до 2 дней, можно забрать награду
        if (diff >= 1) {
          setCanClaimReward(true);
        } else {
          setCanClaimReward(false);
        }
      } catch (err) {
        console.log(err);
        console.log("ERROR ->", localProfile);
        setCurrentAura(await getAuraByName("Stone"));
        updateAndSortAuras(localProfile.AurasList);
        setSortedItems(localProfile.ItemsList);
      }
    };

    setLocalProfile();
  }, []);

  //// Загрузка при входе

  const [auraStats, setAuraStats] = useState({});

  useEffect(() => {
    if (currentAura) {
      setAuraStats(calculateStats(currentAura));
    }
  }, [currentAura]);

  //////////////////////////////////СОРТИРОВКА ИТЕМОВ

  const sortItemsByType = (itemsList) => {
    if (!Array.isArray(itemsList) || itemsList.length === 0) {
      return [];
    }

    const typeOrder = [
      "dungeon-key",
      "potion",
      "ring",
      "glove",
      "necklace",
      "helmet",
      "craft",
    ];

    return itemsList.slice().sort((a, b) => {
      const typeA = typeOrder.indexOf(a.type);
      const typeB = typeOrder.indexOf(b.type);

      // Если оба предмета имеют тип "potion", сортируем их по timer
      if (a.type === "potion" && b.type === "potion") {
        return a.timer - b.timer;
      }

      // Обрабатываем элементы, у которых нет типа в typeOrder
      return (
        (typeA === -1 ? Infinity : typeA) - (typeB === -1 ? Infinity : typeB)
      );
    });
  };

  const setSortedItems = (itemsList) => {
    const sortedItems = sortItemsByType(itemsList);
    dispatch({ type: "UPDATE_ITEMS", payload: itemsList });
    setItems(sortedItems);
  };

  const filterItemsByType = (type) => {
    console.log(localProfile.ItemsList);
    if (type === "all") {
      return setSortedItems(localProfile.ItemsList); // Если "all", возвращаем весь список
    }
    return setItems(
      localProfile.ItemsList.filter((item) => item.type === type)
    ); // Фильтруем по типу
  };

  /////////////////////////КОЛИЧЕСТВО ОТКРЫТЫХ АУР

  function countMatchingAuras(array1, array2) {
    return array1.filter(
      (item1) =>
        item1 && // Check if item1 exists
        array2.some(
          (item2) =>
            item2 && // Check if item2 exists
            item1.title && // Check if item1 has title
            item2.title && // Check if item2 has title
            item1.title === item2.title
        )
    ).length;
  }

  const updateAurasQuantity = (profile) => {
    const quantity = countMatchingAuras(aurasData, profile.AurasList);
    setAurasQuantity(quantity);
  };

  useEffect(() => {
    const update = () => {
      if (localProfile?.AurasList) {
        updateAurasQuantity(localProfile);
      }
    };
    update();
  }, [localProfile?.AurasList]);

  ////////////////////////////////CHANGE MAIN AURA

  const changeMainAura = async (aura) => {
    setSoldIndex(aura.index);
    let newCurrentAura = await getAuraByName(aura.title);
    newCurrentAura = {
      ...newCurrentAura,
      auraLvl: aura.auraLvl || 0,
      auraBg: aura.auraBg,
    };

    await handleAurasUpdate(
      {
        title: currentAura.title,
        probability: currentAura.probability,
        quantity: 1,
        auraLvl: currentAura.auraLvl || 0,
        auraBg: currentAura.auraBg,
      },
      { title: aura.title, quantity: 1 }
    ).then();
    setCurrentAura(newCurrentAura);
    setActiveItem(null);
    audioManager.play("s_mainAura");
  };

  ////////////////////ОБНОВЛЕНИЕ АУРЫ В БАЗЕ ДАННЫХ

  useEffect(() => {
    const fetchProfileData = async () => {
      if (currentAura && localProfile) {
        if (localProfile.mainAura !== currentAura.mainAura) {
          await setProfileAura(localProfile, currentAura);
        }
        salary.current = Math.round(Math.sqrt(currentAura.probability / 2));
      }
    };

    fetchProfileData();
  }, [currentAura]);

  ///////////////////////ОБНОВЛЕНИЕ ОСНОВНОЙ АУРЫ

  const setProfileAura = async (profile, aura) => {
    // await axiosInstance.put(`api/players/${profile.id}`, {
    //   data: {
    //     mainAura: aura.title,
    //     mainAuraLvl: aura.auraLvl,
    //     mainAuraBg: aura.auraBg,
    //     mainAuraRarity: aura.probability,
    //     tgUsername: tgUsername,
    //   },
    // });
    emit("changeMainAura", { playerId: profile.id, aura: aura });
  };

  //////////////СМЕНА ФОНА АУРЫ

  const [currentContainerStyle, setCurrentContainerStyle] =
    useState("current-container");

  useEffect(() => {
    if (!currentAura) {
      return;
    }
    if (currentAura?.auraBg || currentAura?.probability < 1000) {
      setCurrentContainerStyle("current-container");
      return;
    }

    if (currentAura && currentAura.probability >= 1000000) {
      setCurrentContainerStyle("current-container bg-image-05");
      return;
    }

    if (currentAura && currentAura.probability >= 500000) {
      setCurrentContainerStyle("current-container bg-image-04");
      return;
    }
    if (currentAura && currentAura.probability >= 200000) {
      setCurrentContainerStyle("current-container bg-image-03");
      return;
    }
    if (currentAura && currentAura.probability >= 50000) {
      setCurrentContainerStyle("current-container bg-image-02");
      return;
    }
    if (currentAura && currentAura.probability >= 10000) {
      setCurrentContainerStyle("current-container bg-image-01");
      return;
    }

    if (currentAura && currentAura.probability >= 1000) {
      setCurrentContainerStyle("current-container bg-image-00");
      return;
    }
  }, [currentAura]);

  const [additionalLayer, setAdditionalLayer] = useState("");

  //////////////SPIN ЛОГИКА

  const [spinsCount, setSpinsCount] = useState(spinsCountUntilLucky);
  const spinsCountRef = useRef(spinsCount);
  useEffect(() => {
    spinsCountRef.current = spinsCount;
  }, [spinsCount]);

  const [spinCharging, setSpinCharging] = useState(true);
  const [spinWeight, setSpinWeight] = useState(1);
  const spinWeightRef = useRef(spinWeight);
  useEffect(() => {
    spinWeightRef.current = spinWeight;
  }, [spinWeight]);

  const [baseSpinWeight, setBaseSpinWeight] = useState(0);

  const [potionSpinWeight, setPotionSpinWeight] = useState(0);
  const potionSpinWeightRef = useRef(0);

  useEffect(() => {
    potionSpinWeightRef.current = potionSpinWeight;
  }, [potionSpinWeight]);

  const [potionSpeed, setPotionSpeed] = useState(null);
  const potionSpeedRef = useRef(potionSpeed);
  useEffect(() => {
    potionSpeedRef.current = potionSpeed;
  }, [potionSpeed]);

  const [bonusSpinWeight, setBonusSpinWeight] = useState(0);
  const bonusSpinWeightRef = useRef(bonusSpinWeight);

  useEffect(() => {
    bonusSpinWeightRef.current = bonusSpinWeight;
  }, [bonusSpinWeight]);

  const spinSpeed = useRef(5000);

  const startSpinTimer = () => {
    audioManager.play("s_charging");
    let spins = 1;
    setSpinsCount(spins);
    const interval = setInterval(() => {
      if (spins < spinsCountUntilLucky) {
        spins += 1;
        setSpinsCount(spins);
      } else {
        clearInterval(interval);
        setSpinCharging(true);
        if (autoSpinRef.current) {
          setTimeout(() => {
            handleSpinAuras();
          }, 300);
        }
      }
    }, 800);
  };

  ////////////SALE кнопка

  const sellAura = async () => {
    farm(calculateAuraCost(spinAura));
    setShowWin(false);
    setTakeButtonDisabled(true);
    audioManager.play("s_takeAura");
  };

  ////////////AURAS UPDATE

  const auraUpdateQueue = createQueue();

  const [soldIndex, setSoldIndex] = useState(null);

  const handleSell = async (aura, quantity) => {
    setSoldIndex(activeItem.index);
    console.log(activeItem.index);
    await handleAurasUpdate(null, {
      title: aura.title,
      quantity: quantity,
    });
    await farm(calculateAuraCost(activeItem) * quantity);
    setActiveItem(null);
  };

  const [auraAdded, setAuraAdded] = useState(false);

  const handleAurasUpdate = async (addAura, removeAura) => {
    try {
      audioManager.play("s_takeAura");
      setShowWin(false);
      setTakeButtonDisabled(true);
      setAuraAdded(true);
      setTimeout(() => setAuraAdded(false), 200);

      auraUpdateQueue
        .add(
          () =>
            new Promise((resolve, reject) => {
              // Удаляем предыдущие обработчики
              off("itemsUpdateSuccess");
              off("itemsUpdateError");
              off("aurasUpdateSuccess");
              off("auraUpdateError");

              if (addAura?.type === "dungeon-key") {
                emit("itemsUpdate", {
                  playerId: localProfile.id,
                  itemsToUse: addAura,
                  action: "add",
                });

                once("itemsUpdateSuccess", (data) =>
                  resolve({
                    auras: localProfile.AurasList,
                    items: data.ItemsList,
                  })
                );
                once("itemsUpdateError", ({ message }) =>
                  reject(new Error(message))
                );
              } else {
                emit("aurasUpdate", {
                  playerId: localProfile.id,
                  addAura,
                  deleteAura: removeAura,
                });
                if (addAura?.new === true && addAura.probability > 50000) {
                  emit("broadcastRareAura", {
                    id: localProfile.id,
                    firstName: localProfile.firstName,
                    auraName: addAura.title,
                    probability: addAura.probability,
                  });
                }

                once("aurasUpdateSuccess", ({ auras, items }) =>
                  resolve({ auras, items })
                );
                once("auraUpdateError", ({ message }) =>
                  reject(new Error(message))
                );
              }
            })
        )
        .then(({ auras, items }) => {
          // Обновляем состояние через dispatch
          dispatch({ type: "UPDATE_ITEMS", payload: items });

          // Сортируем ауры и предметы
          updateAndSortAuras(auras);
          setSortedItems(items);
          setSoldIndex(null);

          // Обновляем активную ауру, если необходимо
          if (activeItem !== null && addAura?.quantity === 0) {
            auras.forEach(async (aura) => {
              if (aura.title === activeItem.title) {
                let newActiveAura = await getAuraByName(aura.title);
                newActiveAura = {
                  ...newActiveAura,
                  auraBg: aura.auraBg,
                  auraLvl: aura.auraLvl,
                  quantity: aura.quantity,
                };
                setActiveItem(newActiveAura);
                if (currentAura.title === aura.title) {
                  setCurrentAura({
                    ...currentAura,
                    auraLvl: aura.auraLvl,
                    auraBg: aura.auraBg,
                  });
                }
              }
            });
          }
        })
        .catch((error) => {
          console.error("Failed to update auras:", error.message);
          alert("Произошла ошибка: " + error.message);
          setSoldIndex(null);
        });
    } catch (error) {
      console.error("Error in handleAurasUpdate:", error);
    }
  };

  const handleEquipmentUpdate = async (item, action) => {
    try {
      setActiveItem(null); // Сбрасываем активный предмет

      // Удаляем предыдущие обработчики
      off("equipmentUpdateSuccess");
      off("equipmentUpdateError");

      // Отправляем запрос на обновление экипировки
      emit("equipmentUpdate", {
        playerId: localProfile.id,
        item: item,
        action, // "equip" или "unequip"
      });

      // Обработка успешного обновления от сервера
      once(
        "equipmentUpdateSuccess",
        ({ ItemsList, ring, glove, neck, head }) => {
          setSortedItems(ItemsList); // Обновляем список предметов
          fetchEquipped(ring, glove, neck, head); // Обновляем экипировку
          dispatch({
            type: "UPDATE_EQUIPMENT",
            payload: {
              ItemsList: ItemsList,
              ring: ring,
              glove: glove,
              neck: neck,
              head: head,
            },
          });
          console.log(
            "Equipment successfully updated on server and local profile."
          );
        }
      );

      // Обработка ошибки на сервере
      once("equipmentUpdateError", ({ message }) => {
        console.error("Error updating equipment on server:", message);
        addToast(message, "error"); // Показываем уведомление об ошибке
      });
    } catch (error) {
      console.error("Error in handleEquipmentUpdate:", error);
    }
  };

  ///////////смена цвета ника

  const [bgColor, setBgColor] = useState("#1f1f1f");
  const [textColor, setTextColor] = useState("#7a7a7a");

  const [nameTimer, setNameTimer] = useState("");

  const handleNameClick = () => {
    const newBgColor = getRandomColor();
    if (nameTimer) {
      clearTimeout(nameTimer);
    }

    setBgColor(newBgColor);
    setTextColor("#fff");

    const timer = setTimeout(() => {
      setBgColor("#1f1f1f");
      setTextColor("#7a7a7a");
    }, 5000);
    setNameTimer(timer);
  };

  //////////////////////////MINI GAME

  const [clickCount, setClickCount] = useState(0);
  const [comboClicks, setComboClicks] = useState(0);
  const clickSalary = useRef(0);
  const [coinCounterOpacity, setClickCounterOpacity] = useState(0);
  const [auraOpacity, setAuraOpacity] = useState(1);

  const [coinCounterTimer, setCoinCounterTimer] = useState("");
  const [maxClicks, setMaxClicks] = useState(5);

  const [isMiniGameActive, setIsMiniGameActive] = useState(false);

  const startMiniGame = () => {
    audioManager.play("s_gameBg");
    setIsMiniGameActive(true);
    setComboClicks(0);
    setAuraOpacity(0.3);
  };

  const endMiniGame = () => {
    setTimeout(() => {
      audioManager.stop("s_gameBg");
      setIsMiniGameActive(false);
      setAuraOpacity(1);
      audioManager.play("s_tapGameLoose");
    }, 100);
    if (comboClicks > localProfile.bestCombo) {
      emit("updateBestCombo", {
        playerId: localProfile.id,
        combo: comboClicks,
      });
      localProfile.bestCombo = comboClicks;
    }
  };

  const handleScore = () => {
    setClickCount((prevCount) => prevCount + 1);
    const randomNumber = Math.random() * (1.5 - 0.8) + 0.8;
    audioManager.setRate("s_tapGamePoint", randomNumber);
    audioManager.play("s_tapGamePoint");
    setComboClicks((prevCount) => prevCount + 1);
    // imageTap();
  };

  useEffect(() => {
    const gameScoring = () => {
      if (clickCount >= maxClicks) {
        setClickCount(0);
        let multiplyer = 1 + comboClicks / 70;
        clickSalary.current = Math.round(salary.current * multiplyer);

        farm(clickSalary.current);

        const clickEvent = new CustomEvent("luck-click");
        document.dispatchEvent(clickEvent);
      }

      setClickCounterOpacity(1);
      if (coinCounterTimer) {
        clearTimeout(coinCounterTimer);
      }

      const timer = setTimeout(() => {
        setClickCount(0);
        setClickCounterOpacity(0);
      }, 2000);
      setCoinCounterTimer(timer);
    };
    gameScoring();
  }, [clickCount]);

  const auraContainerRef = useRef();

  ///////////////////НОВЫЙ СПИН

  const addDungeon = (num) => {
    if (num > localProfile.openDungeons) {
      // Удаляем предыдущий обработчик
      off("addDungeonSuccess");

      // Отправляем запрос на добавление данжа
      emit("addDungeon", {
        playerId: localProfile.id,
        newDungeonNumber: num,
      });

      // Обработка успешного обновления от сервера
      once("addDungeonSuccess", ({ newDungeonNumber }) => {
        console.log(newDungeonNumber, "NEW DUNGEON NUM");

        dispatch({ type: "UPDATE_DUNGEONS", payload: newDungeonNumber });
      });
    }
  };

  const preloadImage = (imgSrc) => {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.src = imgSrc;
      img.onload = () => {
        resolve();
      };
      img.onerror = (err) => {
        reject(err);
      };
    });
  };

  const aurasLength = 30;

  const ZERO = (120 * aurasLength + 6 * aurasLength - 1) / 2;
  const [spinTransform, setSpinTransform] = useState("");
  const [showWin, setShowWin] = useState(false);
  const isSpinAuraNewRef = useRef(false);

  const handleSpinAuras = (e) => {
    if (spinning || !spinCharging || showWin) {
      audioManager.play("s_spinError");
      if (e) {
        pop(e);
      }
      return;
    }

    off("addSpinSuccess");
    emit("addSpin", {
      playerId: localProfile.id,
    });
    once("addSpinSuccess", ({ newSpinsCount }) => {
      dispatch({ type: "UPDATE_SPINS", payload: newSpinsCount });
    });

    audioManager.play("s_spin2");
    audioManager.play("spinSound");
    let auraList = localProfile.AurasList || [];
    if (e) {
      Ripple(e);
    }
    let isAuraNew;

    setSpinsCount((current) => current - 1);
    setSpinTransform(ZERO - 252);
    setSpinning(true);
    sendSpinning(true);
    let auraArr = [];

    for (let i = 0; i < aurasLength; i++) {
      let aura = getRandomAura(spinWeightRef.current);
      let rarity = getRarity(aura.probability);
      let rarityColor = getRarityColor(rarity);

      aura = {
        ...aura,
        key: i,
        rarity: rarity,
        rarityColor: rarityColor,
        type: "aura",
      };
      auraArr.push(aura);
    }
    let addDungeonKey = 0;
    if (currentAura.probability >= 1000) {
      addDungeonKey = getRandomNumber(0, 100);
    }

    if (addDungeonKey >= 30) {
      auraArr[getRandomNumber(0, 29)] = {
        title: "Dungeon key",
        key: "Dungeon key",
        probability: 1000,
        rarityColor: "#CEBB80",
        img: "adventure-images/dungeon-key.webp",
        miniimg: "adventure-images/120px/dungeon-key.webp",
        type: "dungeon-key",
      };
    }
    setRandomAuras(auraArr);
    const randomPosition = Math.random() * 500 * 2 + 2500;

    const card = auraArr[Math.floor(randomPosition / 126)];

    if (!card || !auraList) {
      console.warn("card is undefined, пропускаем спин");

      // Завершаем спин и запускаем следующий, если автоспин активен
      sendSpinning(false);
      setSpinning(false);
      setSpinCharging(false);
      setBonusSpinWeight(0);

      if (autoSpinRef.current && spinsCountRef.current > 0) {
        setTimeout(() => {
          handleSpinAuras();
        }, 300); // короткая задержка перед повтором
      }

      return;
    }
    const index = auraList.findIndex(
      (aura) => card.title === aura.title // Добавлен return
    );
    if (card.type === "aura") {
      if (index === -1 && currentAura.title !== card.title) {
        isSpinAuraNewRef.current = true;
        isAuraNew = true;
      } else {
        isSpinAuraNewRef.current = false;
        isAuraNew = false;
      }
    }

    setTimeout(() => {
      audioManager.stop("spinSound");
      const randomNumber = Math.random() * (1.3 - 0.8) + 0.8;
      audioManager.setRate("s_newAura", randomNumber);
      isAuraNew
        ? audioManager.play("s_newAura2")
        : audioManager.play("s_newAura");

      sendSpinning(false);

      let auraData = { ...card, imgLoaded: false };

      // Ждем загрузку изображения, но не дольше, чем время спина
      const imgLoadTimeout = setTimeout(() => {
        setSpinAura(auraData); // Показываем ауру без картинки
        setTakeButtonDisabled(false);
        setShowWin(true);
        setSpinning(false);
      }, spinSpeed.current); // Даем 500 мс на загрузку (можешь изменить)

      preloadImage(card.img).then(() => {
        clearTimeout(imgLoadTimeout); // Если картинка успела загрузиться — отменяем таймер
        setSpinAura({ ...card, imgLoaded: true }); // Показываем ауру с картинкой
        setTakeButtonDisabled(false);
        setShowWin(true);
        setSpinning(false);
      });

      if (spinsCountRef.current <= 0) {
        if (autoSpinRef.current) {
          setTimeout(() => {
            handleAurasUpdate(
              {
                title: card.title,
                probability: card.probability,
                type: card.type,
              },
              null
            );
          }, 1000);
        }
        startSpinTimer();
        setSpinCharging(false);
        setBonusSpinWeight(0);
        return;
      }

      if (autoSpinRef.current) {
        setTimeout(() => {
          if (spinsCountRef.current > 1) {
            handleAurasUpdate(
              {
                title: card.title,
                probability: card.probability,
                type: card.type,
                new: true,
              },
              null
            );

            setTimeout(() => {
              handleSpinAuras();
            }, 100);
            return;
          }
          if (spinsCountRef.current === 1) {
            if (glove?.bonusSpinLuck > 0) {
              setBonusSpinWeight(glove.bonusSpinLuck);
            } else {
              setBonusSpinWeight(10);
            }
            audioManager.play("s_useItem");

            handleAurasUpdate(
              {
                title: card.title,
                probability: card.probability,
                type: card.type,
                new: true,
              },
              null
            );
            setTimeout(() => {
              handleSpinAuras();
            }, 100);
          }
        }, 500);
      } else {
        if (spinsCountRef.current === 1) {
          if (glove?.bonusSpinLuck > 0) {
            setBonusSpinWeight(glove.bonusSpinLuck);
          } else {
            setBonusSpinWeight(10);
          }
          audioManager.play("s_useItem");

          return;
        }
      }
    }, spinSpeed.current + 200);

    setTimeout(() => {
      setSpinTransform(ZERO - randomPosition);
    }, 10);
  };

  //////////////////////////CITY

  const openCity = () => {
    if (!spinning && !showWin) {
      if (
        nowOpen !== "city" &&
        nowOpen !== "shop" &&
        nowOpen !== "blacksmith" &&
        nowOpen !== "tailor"
      ) {
        setNowOpen("city");
        setSortedItems(localProfile.ItemsList);
        audioManager.stopAll();
        audioManager.play("s_city");
      } else {
        setNowOpen(null);
        audioManager.stopAll();
        audioManager.play("s_auraBg");
      }
      audioManager.play("s_click01");
    }
  };

  const openPirate = () => {
    if (!spinning && !showWin) {
      audioManager.stopAll();
      audioManager.play("s_click01");
      audioManager.play("s_tailor");
      setNowOpen("pirate");
    }
  };

  //////////////////////////////TAILOR

  const openTailor = () => {
    if (!spinning && !showWin) {
      audioManager.stopAll();
      audioManager.play("s_click01");
      audioManager.play("s_tailor");
      setNowOpen("tailor");
    }
  };

  const [activeCraftItem, setActiveCraftItem] = useState(null);
  const [activeCraftItemInfo, setActiveCraftItemInfo] = useState(null);

  ///////////////////////ALCHEMIST

  const openAlchemist = () => {
    if (!spinning && !showWin) {
      audioManager.stopAll();
      audioManager.play("s_click01");
      audioManager.play("s_skeleton");
      setNowOpen("alchemist");
    }
  };

  //////////////////////////BLACKSMITH

  const openBlacksmith = () => {
    if (!spinning && !showWin) {
      audioManager.stopAll();
      audioManager.play("s_click01");
      audioManager.play("s_blacksmith");
      setNowOpen("blacksmith");
    }
  };

  const [itemInfoList, setItemInfoList] = useState([]);

  useEffect(() => {
    const currentItem = activeCraftItem;
    async function fetchItems() {
      const craftItemInfo = await getItemByName(currentItem.title);
      setActiveCraftItemInfo(craftItemInfo);

      const items = await Promise.all(
        currentItem.needItems.map(async (item) => {
          let itemInfo;
          if (item.type === "aura") {
            itemInfo = await getAuraByName(item.title);
          } else {
            itemInfo = await getItemByName(item.title);
          }
          return { ...item, itemInfo };
        })
      );
      setItemInfoList(items);
    }
    if (currentItem != null) {
      fetchItems();
    }
  }, [activeCraftItem]);

  const hasAllRequiredItems = (requiredItems) => {
    const aurasList = localProfile.AurasList;
    const itemsList = localProfile.ItemsList;
    const { spins, bestCombo } = localProfile;

    return requiredItems.every((requiredItem) => {
      if (requiredItem.type === "aura") {
        // Проверка для аур с проверкой на undefined
        if (!aurasList) return false; // Проверяем, что aurasList существует
        const matchingAura = aurasList.find(
          (aura) => aura && aura.title === requiredItem.title
        );
        return matchingAura && matchingAura.quantity >= requiredItem.quantity;
      } else if (requiredItem.type === "stats") {
        // Проверка для статистики
        if (requiredItem.title === "spins") {
          return spins >= requiredItem.quantity;
        } else if (requiredItem.title === "bestCombo") {
          return bestCombo >= requiredItem.quantity;
        }
        return false; // Если не поддерживается
      } else {
        // Проверка для предметов
        const matchingItem = itemsList.find(
          (item) => item && item.title === requiredItem.title
        );
        return matchingItem && matchingItem.quantity >= requiredItem.quantity;
      }
    });
  };

  const hasRequiredItem = (requiredItem) => {
    // Проверяем, что requiredItem существует и имеет нужные поля
    if (!requiredItem || typeof requiredItem !== "object") return false;

    const { AurasList, ItemsList, spins, bestCombo } = localProfile || {};

    // Проверяем, что localProfile и его поля существуют
    if (
      !AurasList ||
      !ItemsList ||
      spins === undefined ||
      bestCombo === undefined
    ) {
      return false;
    }

    if (requiredItem.type === "aura") {
      // Проверка для ауры (с защитой от undefined в массиве)
      const matchingAura = AurasList.find(
        (aura) => aura?.title === requiredItem.title
      );
      return matchingAura?.quantity >= requiredItem.quantity;
    } else if (requiredItem.type === "stats") {
      // Проверка для статистики
      if (requiredItem.title === "spins") {
        return spins >= requiredItem.quantity;
      } else if (requiredItem.title === "bestCombo") {
        return bestCombo >= requiredItem.quantity;
      }
      return false; // Неподдерживаемый параметр статистики
    } else {
      // Проверка для предмета (с защитой от undefined в массиве)
      const matchingItem = ItemsList.find(
        (item) => item?.title === requiredItem.title
      );
      return matchingItem?.quantity >= requiredItem.quantity;
    }
  };

  const [craftingAnimation, setCraftingAnimation] = useState(false);

  const handleCraft = () => {
    const activeItem = activeCraftItem;
    if (hasAllRequiredItems(activeItem.needItems)) {
      setCraftingAnimation(true);
      if (activeItem.type === "glove") {
        audioManager.play("s_sewing");
      } else if (activeItem.type === "ring" || activeItem.type === "craft") {
        audioManager.play("s_forging");
      } else if (activeItem.type === "potion") {
        audioManager.play("s_craftPotion");
      }
      off("craftItemSuccess");
      off("craftItemError");

      emit("craftItem", {
        playerId: localProfile.id,
        itemToCraft: {
          title: activeItem.title,
          cost: activeItem.cost,
          type: activeItem.type, // Указываем тип создаваемого предмета
          needItems: activeItem.needItems,
        },
      });

      once("craftItemSuccess", (data) => {
        setTimeout(() => {
          setCraftingAnimation(false);
          addToast(t(activeItem.title) + " " + t("received"), "info");
          audioManager.play("s_takeAura");
        }, 2500);

        const { ItemsList, AurasList, ducks } = data; // Получаем обновленные списки и валюту

        setSortedItems(ItemsList); // Обновляем ItemsList в состоянии
        updateAndSortAuras(AurasList);

        dispatch({ type: "UPDATE_ITEMS", payload: ItemsList });
        dispatch({ type: "UPDATE_DUCKS", payload: ducks });
        console.log("Crafting successful. Local profile updated.");
      });

      once("craftItemError", (data) => {
        setCraftingAnimation(false);
        addToast(data.message, "error");
      });
    } else {
      addToast("Нехватает предметов", "error");
    }
  };

  /////////////////////ЧТО ОТКРЫТО СЕЙЧАС

  const [nowOpen, setNowOpen] = useState(null);

  //////////////////////SHOP

  useEffect(() => {
    sendNowOpen(nowOpen);
    // Если здесь не требуется дополнительная логика очистки, функция возврата не нужна
  }, [nowOpen]);

  const openShop = () => {
    if (!spinning && !showWin) {
      setNowOpen("shop");
      audioManager.stopAll();
      audioManager.play("s_shopBg3");
      audioManager.play("s_click01");
    }
  };

  const handlePick = (potion) => {
    try {
      emit("purchaseItem", {
        playerId: localProfile.id,
        item: potion,
        cost: 0,
      });

      // Обработка успешного обновления от сервера
      once("purchaseSuccess", (data) => {
        audioManager.play("s_takeAura");

        const { items, ducks } = data;
        setSortedItems(items);
        dispatch({ type: "UPDATE_ITEMS", payload: items });
        // sendLocalProfileData(newLocalProfile);
        console.log("Items successfully updated on server and local profile.");
      });

      // Обработка ошибки на сервере
      once("purchaseError", ({ message }) => {
        console.error("Error updating items on server:", message);
      });
    } catch (error) {
      console.error("Error in purchaseItem:", error);
    }
  };

  //////////////////////ИТЕМЫ ИНВЕНТАРЬ

  useEffect(() => {
    const changeSpinWeight = () => {
      setSpinWeight(
        baseSpinWeight +
          bonusSpinWeightRef.current +
          potionSpinWeightRef.current
      );
    };
    changeSpinWeight();
  }, [baseSpinWeight, bonusSpinWeight, potionSpinWeight]);

  const [activeItem, setActiveItem] = useState(null);
  const [items, setItems] = useState([]);

  // useEffect(() => {
  //   if (activeItem) {
  //     console.log(activeItem);
  //   }
  // }, [activeItem]);
  const [ring, setRing] = useState({});
  const [glove, setGlove] = useState({});
  const [helmet, setHelmet] = useState({});
  const [necklace, setNecklace] = useState({});

  useEffect(() => {
    let speedBonus = 5000;

    if (necklace && necklace.speedBonus > 0) {
      speedBonus = speedBonus - necklace.speedBonus;
    }
    if (potionSpeedRef.current > 0) {
      speedBonus = speedBonus - potionSpeedRef.current;
    }
    if (speedBonus > 0) {
      spinSpeed.current = speedBonus;
    } else {
      spinSpeed.current = 100;
    }
  }, [necklace, potionSpeed]);

  useEffect(() => {
    const changeHandStats = () => {
      if (helmet && helmet.spinsCount) {
        setSpinsUntilLucky(helmet.spinsCount);
        setSpinsCount(helmet.spinsCount);
      } else {
        setSpinsUntilLucky(10);
        setSpinsCount(10);
      }
    };
    changeHandStats();
  }, [helmet]);

  const fetchEquipped = async (ring, glove, neck, head) => {
    let leftInfo, rightInfo, helmetInfo, neckInfo;
    if (ring) {
      leftInfo = await getItemByName(ring);
      leftInfo = { ...leftInfo, equipped: true };
      setBaseSpinWeight(leftInfo.luckBonus);
    } else {
      setBaseSpinWeight(0);
    }
    if (glove) {
      rightInfo = await getItemByName(glove);
      rightInfo = { ...rightInfo, equipped: true };
    }
    if (head) {
      helmetInfo = await getItemByName(head);
      helmetInfo = { ...helmetInfo, equipped: true };
    }
    if (neck) {
      neckInfo = await getItemByName(neck);
      neckInfo = { ...neckInfo, equipped: true };
    }

    leftInfo ? setRing(leftInfo) : setRing(null);
    rightInfo ? setGlove(rightInfo) : setGlove(null);
    helmetInfo ? setHelmet(helmetInfo) : setHelmet(null);
    neckInfo ? setNecklace(neckInfo) : setNecklace(null);
  };

  const activeItemDetails = async (item, quantity) => {
    let details = await getItemByName(item.title);

    details = { ...details, quantity: quantity || 1 };

    setActiveItem(details);
  };

  const openItems = () => {
    if (!spinning && !showWin) {
      setActiveItem(null);
      if (nowOpen !== "items") {
        setNowOpen("items");
        audioManager.stopAll();
        audioManager.play("s_click01");
        audioManager.play("s_auraBg");
      } else {
        setNowOpen(null);
        audioManager.play("s_click01");
        setSortedItems(localProfile.ItemsList);
      }
    }
  };

  const [itemsStack, setItemsStack] = useState(null);
  const itemsStackQuantity = useRef(itemsStack?.quantity);

  useEffect(() => {
    if (itemsStack) {
      console.log(itemsStack);

      itemsStackQuantity.current = itemsStack.quantity;
    }
  }, [itemsStack]);

  const applyAllItems = async (item) => {
    applyItem(item, item.quantity);
    setActiveItem(null);
  };

  const [activePotions, setActivePotions] = useState([]);

  const applyItem = async (item, quantity) => {
    const existingPotion = activePotions.find(
      (potion) => potion.title === item.title
    );

    if (!existingPotion) {
      // Если зелье еще не активно, добавляем его
      const endTime = Date.now() + item.timer * 60 * 1000 * quantity;

      const timerId = setInterval(() => {
        setActivePotions(
          (prev) =>
            prev
              .map((potion) => {
                if (potion.title === item.title) {
                  const remainingTime = Math.max(
                    0,
                    Math.ceil((potion.endTime - Date.now()) / 1000)
                  );

                  if (remainingTime <= 0) {
                    clearInterval(potion.timerId); // Очищаем только свой таймер
                    return null; // Флаг для удаления
                  }

                  return { ...potion, remainingTime };
                }
                return potion;
              })
              .filter(Boolean) // Удаляем закончившееся зелье
        );
      }, 1000);

      const newPotion = {
        title: item.title,
        color: item.color,
        miniimg: item.miniimg,
        endTime,
        remainingTime: Math.ceil((endTime - Date.now()) / 1000),
        timerId,
        ...("multiplyer" in item && { multiplyer: item.multiplyer }),
        ...("speedBonus" in item && { speedBonus: item.speedBonus }),
      };

      setActivePotions((prev) => [...prev, newPotion]);
    } else {
      // Если зелье уже активно, увеличиваем время окончания
      setActivePotions((prev) =>
        prev.map((potion) =>
          potion.title === item.title
            ? {
                ...potion,
                endTime: potion.endTime + item.timer * 60 * 1000 * quantity,
                remainingTime: Math.ceil(
                  (potion.endTime +
                    item.timer * 60 * 1000 * quantity -
                    Date.now()) /
                    1000
                ),
              }
            : potion
        )
      );
    }
  };

  useEffect(() => {
    const updateRemainingTimes = setInterval(() => {
      setActivePotions((prev) => {
        const updatedPotions = prev.map((potion) => ({
          ...potion,
          remainingTime: Math.max(
            0,
            Math.ceil((potion.endTime - Date.now()) / 1000)
          ),
        }));

        // Проверяем, изменились ли данные
        const isChanged =
          JSON.stringify(prev) !== JSON.stringify(updatedPotions);
        return isChanged ? updatedPotions : prev;
      });
    }, 1000);

    return () => clearInterval(updateRemainingTimes);
  }, []);

  useEffect(() => {
    // Определяем максимальные значения multiplyer и speedBonus
    const { maxMultiplyer, maxSpeedBonus } = activePotions.reduce(
      (totals, potion) => ({
        maxMultiplyer: Math.max(totals.maxMultiplyer, potion.multiplyer || 0),
        maxSpeedBonus: Math.max(totals.maxSpeedBonus, potion.speedBonus || 0),
      }),
      { maxMultiplyer: 0, maxSpeedBonus: 0 } // Начальные значения
    );

    // Устанавливаем только максимальные значения
    setPotionSpinWeight(maxMultiplyer);
    setPotionSpeed(maxSpeedBonus);
  }, [activePotions]);

  const updateLocalItemsData = ({ ItemsList }) => {
    setSortedItems(ItemsList);
    dispatch({ type: "UPDATE_ITEMS", payload: ItemsList });

    console.log("Items successfully updated on server and local profile.");
  };

  const handleItemRemove = async (item, quantity) => {
    try {
      setActiveItem(null);

      const fetchedItem = await getItemByName(item.title);
      off("itemsUpdateSuccess");
      off("itemsUpdateError");

      emit("itemsUpdate", {
        playerId: localProfile.id,
        itemsToUse: { ...item, quantity }, // Передаем количество
        action: "remove",
      });

      // Применение эффектов предмета на клиенте
      if (fetchedItem.multiplyer && fetchedItem.multiplyer > 0) {
        setPotionSpinWeight(fetchedItem.multiplyer * quantity);
      }
      if (fetchedItem.speedBonus && fetchedItem.speedBonus > 0) {
        setPotionSpeed(fetchedItem.speedBonus * quantity);
      }

      if (item.type === "potion") {
        audioManager.play("s_usePotion");
      } else {
        audioManager.play("s_useItem");
      }

      // Обработка успешного обновления
      once("itemsUpdateSuccess", ({ ItemsList }) => {
        setSortedItems(ItemsList);
        dispatch({ type: "UPDATE_ITEMS", payload: ItemsList });
        applyItem(item, quantity);

        console.log("Items successfully updated on server and local profile.");
      });

      // Обработка ошибок
      once("itemsUpdateError", ({ message }) => {
        console.error("Error updating items on server:", message);
        alert("Произошла ошибка при обновлении предметов: " + message);
      });
    } catch (error) {
      console.error("Error in handleItemRemove:", error);
    }
  };

  //////////////////////////АУРЫ ИНВЕНТАРЬ

  const openAuras = () => {
    if (!spinning && !showWin) {
      if (nowOpen !== "auras") {
        setNowOpen("auras");
        audioManager.stopAll();
        audioManager.play("s_click01");
        audioManager.play("s_auraBg");
        setSortedItems(localProfile.ItemsList);
      } else {
        audioManager.play("s_click01");
        setNowOpen(null);
      }
    }
  };

  const [randomAuras, setRandomAuras] = useState([]);

  const [autoSpin, setAutoSpin] = useState(false);
  const autoSpinRef = useRef(autoSpin);

  useEffect(() => {
    autoSpinRef.current = autoSpin;
    if (autoSpin) {
      handleSpinAuras();
    }
  }, [autoSpin]);

  ////////////////////////////////ADVENTURES

  const [activeDungeon, setActiveDungeon] = useState();
  const [activeDungeonLoot, setActiveDungeonLoot] = useState([]);

  const openAdventures = () => {
    if (!spinning && !showWin) {
      audioManager.stopAll();
      audioManager.play("s_click01");
      audioManager.play("s_adventures");
      setNowOpen("adventures");
    }
  };

  const openDungeonInfo = async (dungeon) => {
    let itemsArray = [];
    for (const item of dungeon.bossLoot) {
      const lootItem = await getItemByName(item.title);
      if (lootItem) {
        itemsArray.push(lootItem);
      }
    }
    setActiveDungeonLoot(itemsArray);
    setActiveDungeon(dungeon);
  };

  const openDungeon = (dungeon) => {
    audioManager.stopAll();
    audioManager.play("s_click01");
    audioManager.play("s_dungeon01");
    setActiveDungeonLoot([]);
    off("itemsUpdateSuccess");
    off("itemsUpdateError");

    emit("itemsUpdate", {
      playerId: localProfile.id,
      itemsToUse: [{ title: "Dungeon key" }],
      action: "remove",
    });

    once("itemsUpdateSuccess", async ({ ItemsList }) => {
      addToast(t("-1 Dungeon key"), "info");
      setNowOpen("dungeon");
      setActiveDungeon(dungeon);
      setSortedItems(ItemsList);
    });
    once("itemsUpdateError", async ({ message }) => {
      addToast(t("You don't have the keys to get into the dungeon"), "error");
    });
  };

  const [canClaimReward, setCanClaimReward] = useState(false);

  const claimDailyReward = () => {
    // Отправляем запрос на сервер
    setCanClaimReward(false);
    emit("claimDailyReward", { tgId });
    once("dailyRewardResponse", (response) => {
      // Используем socket.once
      if (response.success) {
        addToast(
          `Награда получена: ${response.reward.dealDucks} DD`,
          "success"
        );
        dispatch({
          type: "UPDATE_DEAL_DUCKS",
          payload: response.newDealducks,
        });
      } else {
        addToast(response.message, "error");
      }
    });
  };

  return (
    <>
      {spinning && (
        <SpinningWindow
          {...{
            motion,
            t,
            spinWeight,
            spinTransform,
            randomAuras,
            spinSpeed,
          }}
        ></SpinningWindow>
      )}
      <AnimatePresence>
        {showWin && (
          <>
            <motion.div
              animate={{
                opacity: 1,
              }}
              exit={{ opacity: 0 }}
              className="show-win-backdrop"
            ></motion.div>
            <div className="show-win">
              <motion.div
                style={{ outline: `2px solid ${spinAura.rarityColor} ` }}
                className="show-win-container"
                initial={{
                  opacity: 0,
                  scale: 0.9,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                }}
                exit={{ scale: 0.8, opacity: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 260,
                  damping: 20,
                  duration: 0.1,
                }}
              >
                <div
                  style={{
                    backgroundColor: spinAura.rarityColor,
                  }}
                  className="show-win-name"
                >
                  <h3>{t(spinAura.title)}</h3>
                  <p>{t(spinAura.rarity)}</p>
                </div>
                <h3 className="show-win-probability">
                  {spinAura.type === "aura" && "1/" + spinAura.probability}
                  {spinAura.type === "dungeon-key" && t("Item")}
                </h3>
                <div className="show-win-image-container">
                  <img
                    alt="star-bg"
                    className="win-glowing-bg-star"
                    src="/glowing-star2.webp"
                  ></img>
                  <Player
                    autoplay
                    loop
                    src={"stars.json"}
                    style={{
                      position: "absolute",
                      width: "100%",
                      top: "100px",
                      left: 0,

                      zIndex: 10, // Убедитесь, что анимация выше остальных элементов
                    }}
                  ></Player>
                  {spinAura?.webm && (
                    <motion.div
                      initial={{
                        opacity: 0,
                        scale: 0.8,
                      }}
                      animate={{
                        opacity: 1,
                        scale: 1,
                      }}
                      transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 20,
                        duration: 0.3,
                      }}
                    >
                      <video
                        style={{ width: "100%" }}
                        src={spinAura.img}
                        autoPlay
                        loop
                        muted
                      />
                    </motion.div>
                  )}
                  {!spinAura?.webm && (
                    <motion.img
                      initial={{
                        opacity: 0,
                        scale: 0.8,
                      }}
                      animate={{
                        opacity: 1,
                        scale: 1,
                      }}
                      transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 20,
                        duration: 0.3,
                      }}
                      className="win-image"
                      alt="win"
                      src={spinAura.img}
                    ></motion.img>
                  )}

                  <div className="win-price"></div>
                </div>
                {isSpinAuraNewRef.current && (
                  <div className="show-win-new">{t("new")}</div>
                )}
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>
      <div className="main-ui">
        {nowOpen === "adventures" && (
          <>
            <div className="inventory-title">
              <div className="invenory-title-text">{t("Adventures")}</div>
              <TakeIcon
                onClick={() => {
                  setNowOpen("city");
                  audioManager.stopAll();
                  audioManager.play("s_city");
                }}
                className="back-icon"
                fill="#e0e0e0dc"
                size="20px"
              ></TakeIcon>
            </div>
            <motion.div
              initial={{ x: 30, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              className="inventory-container add-ui-container"
            >
              <div>
                <div className="blacksmith-items-wrapper">
                  <>
                    {adventuresList.map((dungeon, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          // Проверяем, доступен ли данж для открытия
                          if (localProfile?.openDungeons >= index) {
                            openDungeonInfo(dungeon);
                            console.log(dungeon);

                            audioManager.play("s_buttonClick");
                          } else {
                            // Если данж заблокирован, выводим сообщение об ошибке
                            addToast(
                              t("Go through the open dungeons first"),
                              "error"
                            );
                          }
                        }}
                        className="blacksmith-item"
                      >
                        <img
                          className="blacksmith-item-img"
                          src={
                            localProfile?.openDungeons >= index
                              ? dungeon.img
                              : "adventure-images/dungeon-locked.webp"
                          }
                          alt="miniaura"
                        ></img>

                        <div className="blacksmith-item-title">
                          {t(dungeon.title)}
                        </div>
                      </div>
                    ))}
                    <div key={1337} className="blacksmith-item">
                      <img
                        className="blacksmith-item-img"
                        src={"adventure-images/dungeon-locked.webp"}
                        alt="miniaura"
                      ></img>

                      <div className="blacksmith-item-title">
                        {t("Coming soon...")}
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </motion.div>
            {activeDungeonLoot.length > 0 && (
              <>
                <div className="dungeon-info-container">
                  <h6>{t(activeDungeon.title)}</h6>

                  <div className="loot-text">{t("Possible loot")}</div>
                  <div className="loot-items-info">
                    {Array.from(
                      new Map(
                        activeDungeonLoot.map((item) => [item.title, item])
                      ).values()
                    ).map((item, index) => (
                      <div className="loot-item-container" key={index}>
                        <img
                          alt="ducks-image"
                          width="100%"
                          style={{ borderRadius: 4 }}
                          src={item.miniimg}
                        />
                        <div className="loot-item-text">
                          {t(item.title !== "ducks" && item.title)}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div
                    style={{
                      marginTop: 20,
                      backgroundColor: "rgba(127, 44, 204, 0.9)",
                      padding: "4px 8px",
                      borderRadius: 8,
                    }}
                  >
                    <span style={{ color: "rgba(255,255,255,0.8)" }}>
                      {t("RECOMMENDED BP:")} {formatNumber(activeDungeon.bp)}
                    </span>
                  </div>

                  <div style={{ display: "flex", width: "60%", gap: 8 }}>
                    <button
                      onClick={() => {
                        setActiveDungeonLoot([]);
                      }}
                      className="forge-button"
                      style={{ backgroundColor: "rgb(143, 143, 143)" }}
                    >
                      {t("Back")}
                    </button>
                    <button
                      onClick={() => {
                        openDungeon(activeDungeon);
                      }}
                      className="forge-button"
                    >
                      {t("Let's go")}
                    </button>
                  </div>
                </div>
                <div
                  onClick={() => {
                    setActiveDungeonLoot([]);
                  }}
                  className="black-screen"
                  style={{ backgroundColor: "black", opacity: 0.8, zIndex: 4 }}
                ></div>
              </>
            )}
          </>
        )}
        {nowOpen === "dungeon" && (
          <Dungeon
            t={t}
            dungeon={activeDungeon}
            aura={currentAura}
            auraStats={auraStats}
            setNowOpen={setNowOpen}
            farm={farm}
            localProfile={localProfile}
            addDungeon={addDungeon}
            setSortedItems={setSortedItems}
          ></Dungeon>
        )}

        {nowOpen === "auras" && (
          <motion.div
            key="auras-inventory"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <AurasInventory
              {...{
                t,
                aurasQuantity,
                aurasData,
                motion,
                localProfile,
                soldIndex,
                setActiveItem,
              }}
            />
          </motion.div>
        )}

        {nowOpen === "items" && (
          <ItemsInventory
            {...{
              t,
              motion,
              items,
              activeItemDetails,
              setActiveItem,
              ring,
              glove,
              helmet,
              necklace,
              filterItemsByType,
            }}
          ></ItemsInventory>
        )}
        {activeItem != null && (
          <ActiveItem
            {...{
              updateLocalItemsData,
              farm,
              changeDealDucks,
              localProfile,
              changeMainAura,
              activeItem,
              setActiveItem,
              handleItemRemove,
              handleSell,
              motion,
              handleEquipmentUpdate,
              applyAllItems,
              t,
              handleAurasUpdate,
            }}
            itemsList={localProfile.ItemsList}
            currentAuraTitle={currentAura.title}
          ></ActiveItem>
        )}
        {nowOpen === "shop" && (
          <Shop
            {...{
              t,
              audioManager,
              setNowOpen,
              dispatch,
              changeDealDucks,
              localProfile,
              addToast,
              setSortedItems,
            }}
          />
        )}
        {nowOpen === "pirate" && (
          <Pirate
            {...{
              t,
              audioManager,
              setNowOpen,
              dispatch,
              localProfile,
              addToast,
              setSortedItems,
            }}
          />
        )}
        {nowOpen === "blacksmith" && (
          <Blacksmith
            {...{
              t,
              motion,
              forgeItems,
              setActiveCraftItem,
              setActiveCraftItemInfo,
              localProfile,
              setNowOpen,
              itemInfoList,
              handleCraft,
              activeCraftItem,
              hasAllRequiredItems,
              shopItems,
              activeCraftItemInfo,
              hasRequiredItem,
              craftingAnimation,
            }}
          ></Blacksmith>
        )}
        {nowOpen === "tailor" && (
          <>
            <div className="inventory-title">
              <div className="invenory-title-text">{t("ElunaPlace")}</div>
              <TakeIcon
                onClick={() => {
                  setNowOpen("city");

                  audioManager.stopAll();
                  audioManager.play("s_city");
                }}
                className="back-icon"
                fill="#e0e0e0dc"
                size="20px"
              ></TakeIcon>
            </div>
            <motion.div
              initial={{ x: 30, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              className="inventory-container add-ui-container"
            >
              <div>
                <div className="blacksmith-items-wrapper">
                  {tailorItems.map((item, index) => (
                    <div
                      // style={{ backgroundColor: item.color }}
                      key={index}
                      onClick={() => {
                        setActiveCraftItem(item);

                        audioManager.play("s_buttonClick");
                      }}
                      className="blacksmith-item"
                    >
                      <div
                        style={{
                          backgroundColor: hasAllRequiredItems(item.needItems)
                            ? "yellow"
                            : "red",
                        }}
                        className="blacksmith-item-circle"
                      ></div>
                      <img
                        className="blacksmith-item-img"
                        src={item.miniimg}
                        alt="miniaura"
                      ></img>

                      <div className="blacksmith-item-title">
                        {t(item.title)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
            {activeCraftItem != null && (
              <>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="buy-confirm-window"
                >
                  <div className="forge-container">
                    <img
                      alt="divider"
                      className="forge-divider"
                      src="Divider.webp"
                    ></img>
                    <div className="forge-top-container">
                      <img
                        alt={activeCraftItem.miniimg}
                        className="forge-image"
                        src={activeCraftItem.miniimg}
                      ></img>
                      <div className="forge-title-container">
                        <div className="forge-title">
                          {t(activeCraftItem.title)}
                        </div>
                        <div className="forge-description">
                          {activeCraftItemInfo?.type === "glove" && (
                            <>
                              {activeCraftItemInfo.description && (
                                <span>
                                  {t(activeCraftItemInfo.description)}
                                </span>
                              )}
                              {!activeCraftItemInfo.description && (
                                <span>
                                  {t("bonus luck")}{" "}
                                  {activeCraftItemInfo?.bonusSpinLuck}{" "}
                                  {t("every")} {activeCraftItemInfo?.spinsCount}{" "}
                                  {t("spins")}
                                  <br></br>
                                </span>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        width: "100%",
                        marginBottom: "14px",
                        color: "yellow",
                      }}
                    >
                      {t("Ingridients")}
                    </div>
                    <div className="forge-need-wrapper">
                      {itemInfoList.map((item, index) => {
                        return (
                          <div className="forge-need-container" key={index}>
                            <div
                              style={{
                                backgroundColor: hasRequiredItem(item)
                                  ? "yellow"
                                  : "red",
                              }}
                              className="forge-item-quantity"
                            >
                              {item.quantity}
                            </div>
                            <img
                              alt={item?.itemInfo?.miniimg}
                              className="forge-need-img"
                              src={item?.itemInfo?.miniimg}
                            ></img>
                            <div className="forge-need-title">
                              {t(item.title)}
                            </div>
                          </div>
                        );
                      })}
                      <div className="forge-need-container">
                        <div
                          style={{
                            backgroundColor:
                              localProfile.ducks >= activeCraftItem.cost
                                ? "yellow"
                                : "red",
                          }}
                          className="forge-item-quantity"
                        >
                          {activeCraftItem.cost}
                        </div>
                        <img
                          alt="ducks-image.webp"
                          src="ducks-image.webp"
                          className="forge-need-img"
                        ></img>
                        <div className="forge-need-title">DUCK$</div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <button
                        onClick={() => {
                          setActiveCraftItem(null);
                          setActiveCraftItemInfo(null);
                        }}
                        className="forge-button"
                        style={{ backgroundColor: "gray", width: "30%" }}
                      >
                        {t("BACK")}
                      </button>
                      <button onClick={handleCraft} className="forge-button">
                        {t("EMBROIDER")}
                        {<TailorIcon size="24px"></TailorIcon>}
                      </button>
                    </div>
                  </div>
                </motion.div>
                <div
                  onClick={() => {
                    setActiveCraftItem(null);
                    setActiveCraftItemInfo(null);
                  }}
                  className="black-screen"
                  style={{ backgroundColor: "black", opacity: 0.6 }}
                ></div>
                {craftingAnimation && (
                  <div className="crafting-anim">
                    <Player
                      src={sewingAnim}
                      loop
                      autoplay
                      style={{ height: "250px" }}
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}

        {nowOpen === "alchemist" && (
          <>
            <div className="inventory-title">
              <div className="invenory-title-text">{t("ChonkPlace")}</div>
              <TakeIcon
                onClick={() => {
                  setNowOpen("city");

                  audioManager.stopAll();
                  audioManager.play("s_city");
                }}
                className="back-icon"
                fill="#e0e0e0dc"
                size="20px"
              ></TakeIcon>
            </div>
            <motion.div
              initial={{ x: 30, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              className="inventory-container add-ui-container"
            >
              <div>
                <div className="blacksmith-items-wrapper">
                  {alchemistItems.map((item, index) => (
                    <div
                      // style={{ backgroundColor: item.color }}
                      key={index}
                      onClick={() => {
                        setActiveCraftItem(item);

                        audioManager.play("s_buttonClick");
                      }}
                      className="blacksmith-item"
                    >
                      <div
                        style={{
                          backgroundColor: hasAllRequiredItems(item.needItems)
                            ? "yellow"
                            : "red",
                        }}
                        className="blacksmith-item-circle"
                      ></div>
                      <img
                        className="blacksmith-item-img"
                        src={item.miniimg}
                        alt="miniaura"
                      ></img>

                      <div className="blacksmith-item-title">
                        {t(item.title)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {shopItems.length === 0 && (
                <div style={{ textAlign: "center", padding: "30px 10px" }}>
                  {t("empty")}
                </div>
              )}
            </motion.div>
            {activeCraftItem != null && (
              <>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="buy-confirm-window"
                >
                  <div className="forge-container">
                    <img
                      alt="Divider"
                      className="forge-divider"
                      src="Divider.webp"
                    ></img>
                    <div className="forge-top-container">
                      <img
                        alt={activeCraftItem.miniimg}
                        className="forge-image"
                        src={activeCraftItem.miniimg}
                      ></img>
                      <div className="forge-title-container">
                        <div className="forge-title">
                          {t(activeCraftItem.title)}
                        </div>
                        <div className="forge-description">
                          <>
                            {activeCraftItemInfo?.multiplyer > 0 && (
                              <div>
                                {t("luck")} +{activeCraftItemInfo.multiplyer}{" "}
                                <br />
                                {t("duration")} {activeCraftItemInfo.timer}{" "}
                                {t("min")}
                              </div>
                            )}
                            {activeCraftItemInfo?.speedBonus > 0 && (
                              <div>
                                {t("spin time")} -
                                {activeCraftItemInfo.speedBonus / 1000}{" "}
                                {t("sec")} <br />
                                {t("duration")} {activeCraftItemInfo.timer}{" "}
                                {t("min")}
                              </div>
                            )}
                          </>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        width: "100%",
                        marginBottom: "14px",
                        color: "yellow",
                      }}
                    >
                      {t("Ingridients")}
                    </div>
                    <div className="forge-need-wrapper">
                      {itemInfoList.map((item, index) => {
                        return (
                          <div className="forge-need-container" key={index}>
                            <div
                              style={{
                                backgroundColor: hasRequiredItem(item)
                                  ? "yellow"
                                  : "red",
                              }}
                              className="forge-item-quantity"
                            >
                              {item.quantity}
                            </div>
                            <img
                              alt="forge-need-img"
                              className="forge-need-img"
                              src={item?.itemInfo?.miniimg}
                            ></img>
                            <div className="forge-need-title">
                              {t(item.title)}
                            </div>
                          </div>
                        );
                      })}
                      {activeCraftItem.cost > 0 && (
                        <div className="forge-need-container">
                          <div
                            style={{
                              backgroundColor:
                                localProfile.ducks >= activeCraftItem.cost
                                  ? "yellow"
                                  : "red",
                            }}
                            className="forge-item-quantity"
                          >
                            {activeCraftItem.cost}
                          </div>
                          <img
                            alt="ducks-image"
                            src="ducks-image.webp"
                            className="forge-need-img"
                          ></img>
                          <div className="forge-need-title">DUCK$</div>
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <button
                        onClick={() => {
                          setActiveCraftItem(null);
                          setActiveCraftItemInfo(null);
                        }}
                        className="forge-button"
                        style={{ backgroundColor: "gray", width: "30%" }}
                      >
                        {t("BACK")}
                      </button>
                      <button onClick={handleCraft} className="forge-button">
                        {t("BREW")}
                        {<AlchemistIcon size="24px"></AlchemistIcon>}
                      </button>
                    </div>
                  </div>
                </motion.div>
                <div
                  onClick={() => {
                    setActiveCraftItem(null);
                    setActiveCraftItemInfo(null);
                  }}
                  className="black-screen"
                  style={{ backgroundColor: "black", opacity: 0.6 }}
                ></div>
                {craftingAnimation && (
                  <div className="crafting-anim">
                    <Player
                      src={alchemistAnim}
                      loop
                      autoplay
                      style={{ height: "250px" }}
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}

        {nowOpen === "city" && (
          <CityWindow
            t={t}
            setNowOpen={setNowOpen}
            motion={motion}
            openShop={openShop}
            openBlacksmith={openBlacksmith}
            openAdventures={openAdventures}
            openAlchemist={openAlchemist}
            openTailor={openTailor}
            openPirate={openPirate}
          ></CityWindow>
        )}
        <>
          {currentAura && nowOpen === null && (
            <div>
              {canClaimReward && (
                <div className="reward-backscreen">
                  <div className="reward-container">
                    <div className="header-text">{t("DAILY REWARD")}</div>

                    <div className="reward-window">
                      {dailyRewards.map((reward, index) => (
                        <div
                          key={index}
                          className={
                            (localProfile.streak || 0) === index
                              ? "reward-item-container reward-today"
                              : "reward-item-container"
                          }
                        >
                          <img
                            alt="reward-img"
                            className="reward-img"
                            src={reward.miniimg}
                          ></img>
                          <div>{reward.quantity}</div>
                        </div>
                      ))}
                    </div>
                    <h6
                      style={{
                        marginTop: 10,
                        width: "80%",
                        textAlign: "center",
                        fontSize: 12,
                        lineHeight: "1.2em",
                      }}
                    >
                      {t("Come back every day to increase the reward")}
                    </h6>
                    <img
                      alt="dailyGoose"
                      className="reward-top-image"
                      src="dailyGoose.webp"
                    ></img>
                    <motion.button
                      whileTap={{ y: 5 }}
                      className="forge-button"
                      onClick={() => claimDailyReward()}
                    >
                      {t("CLAIM")}
                    </motion.button>
                  </div>
                </div>
              )}
              <div
                style={{
                  backgroundColor: currentAura.color,
                }}
                className="current-name-container"
              >
                <div className="current-name">
                  {t(currentAura.title) +
                    (currentAura.auraLvl > 0 ? ` +${currentAura.auraLvl}` : "")}
                </div>
                <div
                  className="current-rarity"
                  style={{ color: currentAura.color }}
                >
                  {"1/" +
                    formatNumber(
                      calculateProbability(
                        currentAura.probability,
                        currentAura.auraLvl
                      )
                    )}
                </div>
              </div>
              <div
                style={{
                  backgroundImage: currentAura?.auraBg
                    ? isMiniGameActive
                      ? ""
                      : `url(${auraBgList[currentAura.auraBg].auraBg})`
                    : "",
                }}
                className={
                  isMiniGameActive ? "current-container" : currentContainerStyle
                }
              >
                <div className="main-aura-panel-container">
                  <div className="main-aura-panel">
                    <motion.span
                      initial={{ scale: 1 }}
                      whileTap={{
                        scale: 1.3,
                      }}
                      transition={{
                        duration: 0.1,
                        type: "spring",
                        stiffness: 150,
                      }}
                      onTap={handleNameClick}
                      style={{
                        backgroundColor: bgColor,
                        color: textColor,
                      }}
                      className="player-name"
                    >
                      {localProfile && localProfile.firstName}
                    </motion.span>

                    <div
                      style={{
                        opacity: coinCounterOpacity,
                        transition: ".3s ease",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <ClickBar
                        color={currentAura?.color}
                        clickcount={clickCount}
                        maxClicks={maxClicks}
                      />
                      <LuckAnimation count={clickSalary.current} />
                    </div>
                    <motion.div
                      initial={{ y: 10, opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      key={spinWeight}
                      transition={{ type: "spring", stiffness: 100 }}
                      className={
                        bonusSpinWeight === 0
                          ? "player-name luck-bonus"
                          : "player-name luck-bonus last-spin"
                      }
                    >
                      <span>
                        {t("Luck")} x{spinWeight > 1 ? spinWeight : 1}
                      </span>
                    </motion.div>
                  </div>
                </div>
                {additionalLayer && (
                  <img
                    alt="additionalLayer"
                    style={{
                      width: "100%",
                      left: 0,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                    src={additionalLayer}
                  />
                )}
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    top: 0,
                    left: 0,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{ backgroundColor: currentAura?.rarityColor }}
                    className="aura-rarity"
                  >
                    {t(currentAura?.rarity)}
                  </div>
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      gap: 12,
                      justifyContent: "space-around",
                      backgroundColor: "rgb(0, 0, 0)",
                      padding: "6px 0px",
                      paddingRight: "16px",
                      paddingLeft: "7px",
                      borderRadius: "0px 4px 30px 0px",
                      fontSize: 12,
                    }}
                  >
                    <div
                      style={{ display: "flex", gap: 2, alignItems: "center" }}
                    >
                      <BpIcon size="12px" fill="yellow" />
                      {formatNumber(auraStats?.bp)}
                    </div>
                  </div>
                </div>

                {itemsStack && (
                  <div
                    onClick={() => setItemsStack(null)}
                    style={{ backgroundColor: itemsStack.color }}
                    className="items-stack-container"
                  >
                    <img
                      alt="potion-image"
                      width={50}
                      src={itemsStack.miniimg}
                    ></img>

                    <div className="items-stack-quantity">
                      {itemsStack.quantity}
                    </div>
                  </div>
                )}

                <motion.h4
                  key={comboClicks}
                  initial={{ y: 5 }}
                  animate={{ y: 0 }}
                  transition={{
                    duration: 0.1,
                    type: "spring",
                    easeInOut,
                  }}
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: 15,
                    opacity: comboClicks > maxClicks ? coinCounterOpacity : 0,
                    transition: ".3s ease",
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingTop: "5px",
                  }}
                >
                  COMBO x{comboClicks}
                </motion.h4>
                {!isMiniGameActive && (
                  <PotionContainer
                    onClick={(e) => Ripple(e)}
                    addPotionToInventory={handlePick}
                    glove={glove}
                  ></PotionContainer>
                )}

                <motion.div
                  ref={auraContainerRef}
                  animate={
                    currentAura?.webm ? false : { y: [-5, 5], scale: 1.05 }
                  }
                  transition={{
                    repeat: Infinity,
                    duration: 5,
                    repeatType: "reverse",
                  }}
                  // Запуск мини-игры при тапе
                  className="aura-container"
                >
                  {!currentAura?.webm && (
                    <motion.img
                      style={{ opacity: 0.3 }}
                      initial={{ scale: 0.8, opacity: 0 }}
                      animate={{ scale: 1, opacity: auraOpacity }}
                      onTapStart={isMiniGameActive ? "" : startMiniGame}
                      alt="auraimg"
                      className="aura-image"
                      src={`/${currentAura.img}`}
                    ></motion.img>
                  )}

                  {currentAura?.webm && (
                    <>
                      <motion.video
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: auraOpacity }}
                        className="aura-image"
                        onTapStart={isMiniGameActive ? "" : startMiniGame}
                        src={currentAura.img}
                        autoPlay
                        loop
                        muted
                      />
                    </>
                  )}
                </motion.div>
                <AnimatePresence>
                  {isMiniGameActive && (
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                    >
                      <MiniGame onEndGame={endMiniGame} onScore={handleScore} />
                    </motion.div>
                  )}
                </AnimatePresence>

                <ul
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "absolute",
                    left: 0,
                    top: "20%",
                    gap: "6px",
                  }}
                >
                  {activePotions.map((potion) => (
                    <li key={potion.title}>
                      <div
                        style={{ backgroundColor: potion.color }}
                        className="items-stack-container"
                      >
                        <img
                          alt="potionImg"
                          width={26}
                          src={potion.miniimg}
                        ></img>
                        <div className="items-stack-quantity">
                          {Math.floor(potion.remainingTime / 60) > 0 &&
                            `${Math.floor(potion.remainingTime / 60)}m `}
                          {potion.remainingTime % 60}s
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <RareAuraTicker t={t}></RareAuraTicker>
            </div>
          )}
        </>

        {nowOpen !== "dungeon" && (
          <div className="spin-table-container">
            <div className="spin-buttons">
              <div className="bottom-buttons">
                <motion.button
                  whileTap={{ scale: 0.95 }}
                  transition={{ duration: 0.1 }}
                  disabled={spinning || isMiniGameActive}
                  onClick={openItems}
                  className={
                    nowOpen === "items"
                      ? "bottom-item bottom-item-clicked"
                      : "bottom-item"
                  }
                >
                  <InventoryIcon size="30px"></InventoryIcon>
                </motion.button>

                <motion.button
                  whileTap={{ scale: 0.95 }}
                  transition={{ duration: 0.1 }}
                  initial={{ scale: 1.2 }}
                  animate={{ scale: auraAdded ? 1.2 : 1 }}
                  disabled={spinning || isMiniGameActive}
                  onClick={openAuras}
                  className={
                    nowOpen === "auras"
                      ? "bottom-item bottom-item-clicked"
                      : "bottom-item"
                  }
                >
                  <AurasIcon size="30px"></AurasIcon>
                </motion.button>
                <motion.button
                  whileTap={{ scale: 0.95 }}
                  transition={{ duration: 0.1 }}
                  disabled={spinning || isMiniGameActive}
                  onClick={openCity}
                  className={
                    nowOpen === "city"
                      ? "bottom-item bottom-item-clicked"
                      : "bottom-item"
                  }
                >
                  <CityIcon size="30px"></CityIcon>
                </motion.button>
              </div>
              <div style={{ display: "flex", gap: "8px", height: "40%" }}>
                <motion.button
                  whileTap={{ scale: 0.97 }}
                  transition={{ duration: 0.1 }}
                  disabled={
                    takeButtonDisabled ||
                    autoSpin ||
                    spinAura.type === "dungeon-key"
                  }
                  className="button-sell"
                  onClick={(e) => {
                    sellAura();
                    PopCoins(e, spinAura.probability);
                  }}
                >
                  {t("sell")}
                  <SellIcon
                    style={{ marginLeft: "5px" }}
                    size="14px"
                  ></SellIcon>
                </motion.button>
                <motion.button
                  whileTap={{ scale: 0.97 }}
                  transition={{ duration: 0.1 }}
                  disabled={takeButtonDisabled || autoSpin}
                  className={
                    currentAura &&
                    !takeButtonDisabled &&
                    currentAura.probability < spinAura.probability
                      ? "button-take button-take-glow"
                      : "button-take"
                  }
                  onClick={() =>
                    handleAurasUpdate(
                      {
                        title: spinAura.title,
                        probability: spinAura.probability,
                        type: spinAura.type,
                        new: true,
                      },
                      null
                    )
                  }
                >
                  {t("take")}
                  <TakeIcon
                    style={{ marginLeft: "5px" }}
                    size="14px"
                  ></TakeIcon>
                </motion.button>
              </div>
              <div style={{ display: "flex", gap: "8px", height: "40%" }}>
                {localProfile?.autospin && (
                  <motion.button
                    whileTap={{
                      scale: 0.92,
                    }}
                    transition={{ duration: 0.1 }}
                    disabled={showWin}
                    onClick={() => setAutoSpin((current) => !current)}
                    className={
                      autoSpin
                        ? "button-autospin gradient-flow"
                        : "button-autospin"
                    }
                  >
                    {t("AUTO")}
                  </motion.button>
                )}
                <SpinButton
                  disabled={showWin || autoSpin || !spinCharging}
                  clickcount={spinsCount}
                  onClick={handleSpinAuras}
                  spinscountuntillucky={spinsCountUntilLucky}
                  className="button-spin"
                >
                  <motion.div>
                    {spinning && spinsCountRef.current > 0 && !autoSpin && (
                      <div className="button-spin-container">
                        <Player
                          autoplay
                          loop
                          src="https://lottie.host/0509e93b-7e8e-4492-83ec-340bbe8f545c/eN20dLixkx.json"
                          style={{ height: "25px" }}
                        ></Player>
                      </div>
                    )}
                    {spinsCountRef.current > 0 && autoSpin && spinCharging && (
                      <div className="button-spin-container">
                        <Player
                          autoplay
                          loop
                          src="https://lottie.host/0509e93b-7e8e-4492-83ec-340bbe8f545c/eN20dLixkx.json"
                          style={{ height: "25px" }}
                        ></Player>
                      </div>
                    )}
                    {spinning && spinsCountRef.current === 0 && (
                      <div className="button-spin-container">
                        <Player
                          autoplay
                          loop
                          src="https://lottie.host/ae8f83eb-54a8-47fd-badc-01764f3ace5f/OJdavwCkrV.json"
                          style={{ height: "45px" }}
                        ></Player>
                      </div>
                    )}
                    {!spinning && spinCharging && !autoSpin && t("spin")}
                    {!spinCharging && t("spinloading")}
                  </motion.div>
                </SpinButton>
              </div>
            </div>
          </div>
        )}

        <ToastNotification toasts={toasts} />
      </div>
    </>
  );
};

export default AuraRng;
